// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jg-0";
export var actionModalContentContainer = "_jg-1";